'use strict';
import globalData from "./global.js";
import axios from 'axios';
axios.defaults.withCredentials = true;

//const baseUrl = '/';
const baseUrl = globalData.getDomain() + '/';
//主站地址，发布时需更改
const main_site_base_url = 'http://wm2.127.com';

const school_name = globalData.school_name

export { baseUrl, main_site_base_url, school_name };
/* 用户 */
export const getUserList = (params) => { return axios({ url: baseUrl + 'web_get_user_list', method: 'get', params }); };
export const getQipuList = (params) => { return axios({ url: baseUrl + 'web_get_qipu_list', method: 'get', params }); };



export const userAdd = (params) => { return axios({ url: baseUrl + 'user/add', method: 'get', params }); };
export const userDelete = (params) => { return axios({ url: baseUrl + 'user/delete', method: 'get', params }); };
export const userUpdate = (params) => { return axios({ url: baseUrl + 'user/update', method: 'get', params }); };
export const getUserInfo = () => { return axios({ url: baseUrl + 'user/info', method: 'get' }); };
export const userLoginCheck = () => { return axios({ url: baseUrl + 'user/check', method: 'get' }); };

/* 管理员 */
export const Verify = () => { return axios({ url: baseUrl + 'verify', method: 'get' }); };
export const checkLogin = () => { return axios({ url: baseUrl + 'checkLogin', method: 'get' }); };
export const getAdminLogin = (params) => { return axios({ url: baseUrl + 'admin/login', method: 'post', params }); };
export const getAdminList = (params) => { return axios({ url: baseUrl + 'admin/list', method: 'get', params }); };
export const adminAdd = (params) => { return axios({ url: baseUrl + 'admin/add', method: 'get', params }); };
export const adminDelete = (params) => { return axios({ url: baseUrl + 'admin/delete', method: 'get', params }); };
export const adminUpdate = (params) => { return axios({ url: baseUrl + 'admin/update', method: 'get', params }); };
export const adminLoginCheck = () => { return axios({ url: baseUrl + 'admin/check', method: 'get' }); };
export const getAdminInfo = () => { return axios({ url: baseUrl + 'admin/info', method: 'get' }); };
export const adminSignout = () => { return axios({ url: baseUrl + 'admin/signout', method: 'get' }); };

// /* 地图 */
// export const getMapList 		=(params)=> {return axios({url:baseUrl+'map/list', 		method:'get', params});};
// export const mapAdd 			=(params)=> {return axios({url:baseUrl+'map/add', 		method:'get', params});};
// export const mapDelete 			=(params)=> {return axios({url:baseUrl+'map/delete', 	method:'get', params});};
// export const mapUpdate 			=(params)=> {return axios({url:baseUrl+'map/update', 	method:'get', params});};
// export const getAllMapCount			=(params)=> {return axios({url:baseUrl+'map/count',		method:'get',params});};

// /* shape */
// export const getShapeList 		=(params)=> {return axios({url:baseUrl+'shape/list', 	method:'get', params});};
// export const shapeAdd 			=(params)=> {return axios({url:baseUrl+'shape/add', 	method:'get', params});};
// export const shapeDelete 		=(params)=> {return axios({url:baseUrl+'shape/delete', 	method:'get', params});};
// export const shapeUpdate 		=(params)=> {return axios({url:baseUrl+'shape/update', 	method:'get', params});};

// /* friend */
// export const getFriendList 		=(params)=> {return axios({url:baseUrl+'friend/list', 	method:'get', params});};
// export const friendAdd 			=(params)=> {return axios({url:baseUrl+'friend/add', 	method:'get', params});};
// export const friendDelete 		=(params)=> {return axios({url:baseUrl+'friend/delete', method:'get', params});};
// export const friendUpdate 		=(params)=> {return axios({url:baseUrl+'friend/update', method:'get', params});};

// /* coop */
// export const getCoopMapList 	=(params)=> {return axios({url:baseUrl+'coopmap/list', 	method:'get', params});};
// export const coopMapAdd 		=(params)=> {return axios({url:baseUrl+'coopmap/add', 	method:'get', params});};
// export const coopMapDelete 		=(params)=> {return axios({url:baseUrl+'coopmap/delete',method:'get', params});};
// export const coopMapUpdate 		=(params)=> {return axios({url:baseUrl+'coopmap/update',method:'get', params});};

// /* data */
// export const getDataList 		=(params)=> {return axios({url:baseUrl+'data/list', 	method:'get', params});};
// export const dataAdd 			=(params)=> {return axios({url:baseUrl+'data/add', 		method:'get', params});};
// export const dataDelete 		=(params)=> {return axios({url:baseUrl+'data/delete', 	method:'get', params});};
// export const dataUpdate 		=(params)=> {return axios({url:baseUrl+'data/update', 	method:'post', params});};
// export const getAllDataCount		=(params)=> {return axios({url:baseUrl+'data/count',		method:'get' ,params});};
// /* classify */
// export const getClassifyList    =(params)=> {return axios({url:baseUrl+'classify/list', 	method:'get', params});};
// export const getClassifyChild    =(params)=> {return axios({url:baseUrl+'classify/getChild', 	method:'get', params});};
// export const classifyAdd 			=(params)=> {return axios({url:baseUrl+'classify/add', 		method:'post', params});};
// export const classifyDelete 		=(params)=> {return axios({url:baseUrl+'classify/delete', 	method:'post', params});};
// export const classifyUpdate 		=(params)=> {return axios({url:baseUrl+'classify/update', 	method:'post', params});};
// export const classifyUpdateSort 		=(params)=> {return axios({url:baseUrl+'classify/update_sort', 	method:'post', params});};
// export const classifyUpdateName		=(params)=> {return axios({url:baseUrl+'classify/update_name', 	method:'post', params});};
// export const classifyUpdateShow		=(params)=> {return axios({url:baseUrl+'classify/update_show', 	method:'post', params});};
// /* statis */
// export const getStatisList 		=(params)=> {return axios({url:baseUrl+'api/statis/list', method:'get', params});};
// export const statisAdd 			=(params)=> {return axios({url:baseUrl+'statis/add', 	method:'get', params});};
// export const statisDelete 		=(params)=> {return axios({url:baseUrl+'statis/delete', method:'get', params});};
// export const statisUpdate 		=(params)=> {return axios({url:baseUrl+'statis/update', method:'get', params});};

// /* 位置 */
// export const guessPlace 		=(params)=> {return axios({url: baseUrl + 'pos/city',	method:'get', params:{type:'guess'}});};
// export const searchPlace 		=(params)=> {return axios({url: baseUrl + 'pos/search',	method:'get', params});};

// /*基本设置*/
// export const SaveConfig		=(params)=> {return axios({url: baseUrl + 'config/save',	method:'post', params});};
// export const getConfig		=()=> {return axios({url: baseUrl + 'config/get_config',	method:'get'});};

// /*文件上传下载*/
// //export const uploadImg 			=(params)=> {return axios({url: baseUrl + 'addimg',		method:'post', params});};
// //export const uploadImg 			=(type)=> {return axios({url: baseUrl + 'addimg/'+type+'/',method:'post', params});};

// /* 统计 当天*/
// export const getTodayApiCount 		=()=> {return axios({url:baseUrl+'api/statis/todayCount',method:'get' });};
// export const getTodayRegUserCount 	=()=> {return axios({url:baseUrl+'api/user/todayCount',	method:'get' });};
// export const getTodayRegAdminCount	=()=> {return axios({url:baseUrl+'api/admin/todayCount',method:'get' });};
// export const getTodayMapCount		=()=> {return axios({url:baseUrl+'api/map/todayCount',	method:'get' });};
// export const getTodayShapeCount		=()=> {return axios({url:baseUrl+'api/shape/todayCount',method:'get' });};
// export const getTodayDataCount		=()=> {return axios({url:baseUrl+'api/data/todayCount',	method:'get' });};

// /* 统计 昨天*/
// export const getYesApiCount			=()=> {return axios({url:baseUrl+'api/statis/yesterdayCount',method:'get' });};
// export const getYesAdminCount		=()=> {return axios({url:baseUrl+'api/admin/yesterdayCount',method:'get' });};
// export const getYesUserCount		=()=> {return axios({url:baseUrl+'api/user/yesterdayCount',	method:'get' });};
// export const getYesMapCount			=()=> {return axios({url:baseUrl+'api/map/yesterdayCount',	method:'get' });};
// export const getYesShapeCount		=()=> {return axios({url:baseUrl+'api/shape/yesterdayCount',method:'get' });};
// export const getYesDataCount		=()=> {return axios({url:baseUrl+'api/data/yesterdayCount',	method:'get' });};

// /* 统计 一周*/
// export const getWeekApiCount		=()=> {return axios({url:baseUrl+'api/statis/weekCount',method:'get' });};
// export const getWeekAdminCount		=()=> {return axios({url:baseUrl+'api/admin/weekCount',	method:'get' });};
// export const getWeekUserCount		=()=> {return axios({url:baseUrl+'api/user/weekCount',	method:'get' });};
// export const getWeekMapCount		=()=> {return axios({url:baseUrl+'api/map/weekCount',	method:'get' });};
// export const getWeekShapeCount		=()=> {return axios({url:baseUrl+'api/shape/weekCount',	method:'get' });};
// export const getWeekDataCount		=()=> {return axios({url:baseUrl+'api/data/weekCount',	method:'get' });};

// /* 统计 一月*/
// export const getMonthApiCount		=()=> {return axios({url:baseUrl+'api/statis/monthCount',method:'get' });};
// export const getMonthAdminCount		=()=> {return axios({url:baseUrl+'api/admin/monthCount',method:'get' });};
// export const getMonthUserCount		=()=> {return axios({url:baseUrl+'api/user/monthCount',	method:'get' });};
// export const getMonthMapCount		=()=> {return axios({url:baseUrl+'api/map/monthCount',	method:'get' });};
// export const getMonthShapeCount		=()=> {return axios({url:baseUrl+'api/shape/monthCount',method:'get' });};
// export const getMonthDataCount		=()=> {return axios({url:baseUrl+'api/data/monthCount',	method:'get' });};

// /* 统计 所有*/
// export const getAllApiCount			=()=> {return axios({url:baseUrl+'api/statis/count',	method:'get' });};
// export const getAllAdminCount		=()=> {return axios({url:baseUrl+'api/admin/count',		method:'get' });};
// export const getAllUserCount		=()=> {return axios({url:baseUrl+'api/user/count',		method:'get' });};

// export const getAllShapeCount		=()=> {return axios({url:baseUrl+'api/shape/count',		method:'get' });};
// export const getAllFriendCount		=()=> {return axios({url:baseUrl+'api/friend/count',	method:'get' });};
// export const getAllCoopMapCount		=()=> {return axios({url:baseUrl+'api/coopmap/count',	method:'get' });};

// export const getAllClassifyCount		=()=> {return axios({url:baseUrl+'api/classify/count',		method:'get' });};
// export const getAllStatisCount		=()=> {return axios({url:baseUrl+'api/statis/count',	method:'get' });};

// /* 统计 某天*/
// export const getDayApiCount			=(today)=> {return axios({url:baseUrl+'api/statis/'+today+'/count',	method:'get'});};
// export const getDayAdminCount		=(today)=> {return axios({url:baseUrl+'api/admin/'+today+'/count',	method:'get'});};
// export const getDayUserCount		=(today)=> {return axios({url:baseUrl+'api/user/'+today+'/count',	method:'get'});};
// export const getDayMapCount			=(today)=> {return axios({url:baseUrl+'api/map/'+today+'/count',	method:'get'});};
// export const getDayShapeCount		=(today)=> {return axios({url:baseUrl+'api/shape/'+today+'/count',	method:'get'});};
// export const getDayDataCount		=(today)=> {return axios({url:baseUrl+'api/data/'+today+'/count',	method:'get'});};

/*
    admin: 	"admin",
    coop: 	"coop_maps",
    friend: "friends",
    map: 	"maps",
    shape: 	"shapes",
    statis: "statistic",
    user: 	"users",
    coopmap:"coop_maps",
    data: 	"data_table",
*/


// WEBPACK FOOTER //
// ./src/common/common.js